module.exports = __webpack_public_path__ + "static/assets/02470ceceed9235b943e6b5a9edc8efb.png";